export default "__VITE_ASSET__018c8634__$_?react__"